import { Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import CustomerInformationComponent from "../common/CustomerInformationComponent";
import Timer from "../timer/Timer";
import DialPadKeys from "./DialPadKeys";
import useHttp from "../../../hooks/useHttp";
import { useVoiceIntegId } from "../../utils/VoiceUtils";
import { useVoiceContext } from "../../context/VoiceContext";

const CallAnswered = (props) => {
  let {
    orgNumber,
    parentCallSid,
    callSid,
    lastName,
    endCall,
    callEnded,
    setCallEnded,
    module,
    callObject,
    callNotes,
    setCallNotes,
    callStatus,
    totalCallDuration,
    callNotesFormName,
    setTotalCallDuration,
    callerImageComponent,
    recordId,
    recordLink,
    searchValue,
    appProperties,
    customerNumber,
    skeletonImage,
    skeletonField,
    avatar,
    callProperties,
    setCallProperties,
    customerInfoDetails,
    makeOutboundCall,
    isHoldLoading,
    setIsHoldLoading

  } = props;
  const [enteredNumber, setEnteredNumber] = useState("");
  const [mute, setMute] = useState(false);
  const [keyPad, setKeyPad] = useState(false);
  const [pauseTimer, setPauseTimer] = useState(false);
  const {fetchData} = useHttp();

  const handleKeyPad = () => {
    setKeyPad(!keyPad);
  };
  const handleMute = () => {
    const onMute = !mute;
    setMute(onMute);
    if (callObject) {
      callObject.mute(onMute);
    }
  };

  const voiceIntegId = useVoiceIntegId(appProperties);

  const handleHold = () => {
    const holdStatus = !callProperties?.hold;
    setIsHoldLoading(true);
    setCallProperties((prev) => ({
      ...prev,
      hold: holdStatus,
    }));
    if(holdStatus){
      const payload = {
        callSid: parentCallSid,
        hold: true,
        integId: voiceIntegId,
        configuredNumber: orgNumber,
      };
      fetchData("call/hold", "POST", payload, appProperties)
        .then((res) => {
        })
        .catch((err) => {
        setIsHoldLoading(false);
        setCallProperties((prev) => ({
          ...prev,
          hold: !holdStatus,
        }));
      });
    }else{
      makeOutboundCall("", true);
      setIsHoldLoading(false);
    }
  };

  
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const forceEndCall = () => {
    const payload = {
      callSid: parentCallSid,
      integId: voiceIntegId,
    }
    fetchData("call/end", "POST", payload, appProperties).then((res) => {
      const response = JSON.parse(res);
      if(response?.data?.success === true){
        setCallEnded(true);
      }
    }).catch((err) => {});
  };

  return (
    <div className={`${callStatus} overflow-auto h-100`}>
      <CustomerInformationComponent
        callerImageComponent={callerImageComponent}
        lastName={lastName}
        module={module}
        appProperties={appProperties}
        recordId={recordId}
        recordLink={recordLink}
        endCall={callProperties?.hold ? forceEndCall : endCall}
        searchValue={searchValue}
        customerNumber={customerNumber}
        skeletonImage={skeletonImage}
        skeletonField={skeletonField}
        avatar={avatar}
        callProperties={callProperties}
        showEndCallBtn={true}
        customerInfoDetails={customerInfoDetails}
      />
      <div className="text-white hs-fw-500 hs-fs-18 w-100 hs-h-10">
        <Row className="hs-h-45 w-100">
          <div className="w-100 d-flex justify-content-center">
            <Timer
              pause={pauseTimer}
              setTotalCallDuration={setTotalCallDuration}
              totalCallDuration={totalCallDuration}
              callEnded={callEnded}
              setCallEnded={setCallEnded}
            />
          </div>
        </Row>
        {mute === true && (
          <Row className="hs-h-45 w-100">
            <div className="w-100 d-flex justify-content-center align-items-center">
              <div className="call-actions-text hs-h-7">
                <span className="mute-text">Muted</span>
              </div>
            </div>
          </Row>
        )}
        {
          callProperties?.hold && (
            <div className="w-100 d-flex justify-content-center">
              <div className="call-actions-text hs-h-7">
                {isHoldLoading ? (
                  <span className="hold-text-loading">
                    <span className="loading-dots"></span>
                  </span>
                ) : (
                  <span className="mute-text">Hold</span>
                )}
              </div>
            </div>
          )
        }
      </div>

      {keyPad === true ? (
        <div className="px-4 h-50 w-100 pt-0">
          <div className="hs-h-10 d-flex align-items-center w-100 justify-content-evenly">
            <div className="enteredNumbers d-flex justify-content-center w-100">
              {enteredNumber}
              {enteredNumber ? (
                <div className="d-flex justify-content-end">
                  <div className="clear-Icon d-flex justify-content-end" onClick={() => setEnteredNumber("")}></div>
                </div>
              ) : null}
            </div>
          </div>

          <DialPadKeys numbers={enteredNumber} setNumbers={setEnteredNumber} twilioDevice={callObject} />
        </div>
      ) : (
        <div className="px-4 h-50">
          <Form form={callNotesFormName} name={"callDescription"} rootClassName=" hs-h-90 w-100 call-textarea">
            <Form.Item name="callDescription" initialValue={callNotes} rootClassName="h-100 w-100">
              <textarea className="w-100 h-100 hs-border-16 p-2 ps-3 call-description-textarea" placeholder="Enter Call Description" />
            </Form.Item>
          </Form>
        </div>
      )}

      <div className="hs-h-15 d-flex align-items-center w-100 px-4">
        <div className="d-flex justify-content-center align-items-center flex-row  dialPadActionIcons  w-100">
          <div className={`${mute ? "on-Mute-Icon  cursor-pointer" : "mute-Icon  cursor-pointer"}`} onClick={handleMute} />
          <div className={`${keyPad ? "on-Key-Pad-Icon  cursor-pointer" : "key-Pad-Icon  cursor-pointer"}`} onClick={handleKeyPad} />
          <div className={`${callProperties?.hold ? "on-hold-Icon" : "hold-Icon"} ${callProperties?.callType === "outbound" ? "disabled" : "cursor-pointer"}`} onClick={callProperties?.callType === "outbound" ? undefined : handleHold} />
        </div>
      </div>
    </div>
  );
};

export default CallAnswered;
